import { useSetAtom } from 'jotai'
import Modal from '../../common/modal'
import * as iid from '../../common/bookingElementId'
import { Item } from '../../common/snippets'
import { Box, Button, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import DropDownOA from '../../common/dropDownOA'
import Datepicker from '../../common/datePicker'
import { alertAtom, globalLoaderAtom, modalAtom } from '../../common/jotaiState/globalStateAtoms'
import * as sx from '../../common/stylesInline/report_daily_branch'
import LineinputV2 from '../../common/lineinputV2'
import useToken from '../../helpers/useTokens'
import { useEffect, useState } from 'react'
import { ExpenseMasterHeaders, expenseTypes, paymentCycles, txnTypes } from './contants'
import moment from 'moment'
import { floatFilter, getFloat, navigation1 } from '../../common/helper'
import { GetRequest, PostRequest } from '../../common/api'
import { urls } from '../../common/constants'

export const AddEditHeaderModal = (props) => {
  const setModal = useSetAtom(modalAtom)
  const setLoader = useSetAtom(globalLoaderAtom)
  const setAlert = useSetAtom(alertAtom)
  const { loginData } = useToken()
  const { intCompanyID, intUserID } = loginData
  const [newHeader, setNewHeaser] = useState('')
  const [paymentCycle, setPaymentCycle] = useState(paymentCycles[0])
  const [dayOfMonth, setDayOfMonth] = useState(moment())
  const [txnType, setTxnType] = useState(txnTypes[0])
  const [expenseType, setExpenseType] = useState(expenseTypes[0])
  const [amount, setAmount] = useState(0)
  const [tableData, setTableData] = useState([])
  useEffect(() => {
    if (intCompanyID) {
      getData()
    }
  }, [intCompanyID])
  const getData = () => {
    setLoader(true)
    const data = { intCompanyID }
    GetRequest(urls.getExpenseHeaderMaster, data)
      .then((res) => {
        if (res.status !== 'Success') {
          throw new Error(res?.ErrMessage || 'Request Failed')
        }
        if (!Array.isArray(res.Data.Table) || res.Data.Table.length === 0) {
          throw new Error('No Data Found')
        }
        const list = res.Data.Table.map((col, index) => ({
          ...col,
          dataType: 'entry',
          SN: index + 1,
          disabled: true,
        }))
        setTableData(list)
      })
      .catch((err) => {
        setAlert({ show: true, msg: err.message, nextId: '' })
      })
      .finally(() => setLoader(false))
  }
  const handleChange = (index, value) => {
    const newData = [...tableData]
    newData[index]['Amount'] = +value
    setTableData(newData)
  }
  const OnClose = () => {
    setAlert({ show: false, msg: '', nextId: '' })
    getData()
  }
  const handleEdit = (index, disabled, item) => {
    if (disabled) {
      const newData = [...tableData]
      newData[index].disabled = !disabled
      setTableData(newData)
    } else {
      const payload = {
        CompanyID: intCompanyID,
        UserID: intUserID,
        HeaderID: item.ExpenseId,
        Headername: item.ExpenseHeader,
        PaymentCycleID: item.PaymentCycleID,
        PaymentCycleName: item.PaymentCycleName,
        IsFixed: item.TransactionType === 'Fixed' ? 1 : 0,
        ExpenseTypeID: item.ExpenseTypeId,
        Amount: item.Amount,
      }
      saveChanges(payload)
    }
  }
  const saveChanges = (payload) => {
    PostRequest(urls.expenseHeaderInsertUpdate, payload)
      .then((res) => {
        if (res.status !== 'Success') {
          throw new Error(res?.ErrMessage || 'Request Failed')
        }
        setAlert({ show: true, msg: 'Expense Header Updated Successfully', nextId: '', close: OnClose })
      })
      .catch((err) => {
        setAlert({ show: true, msg: err.message, nextId: '' })
      })
  }
  const addNewHeader = () => {
    if (!newHeader) {
      setAlert({ show: true, msg: 'Please enter header name', nextId: '' })
      return
    }
    if (!paymentCycle?.label) {
      setAlert({ show: true, msg: 'Please select payment cycle', nextId: '' })
      return
    }
    if (!txnType?.id) {
      setAlert({ show: true, msg: 'Please select transaction type', nextId: '' })
      return
    }
    if (!expenseType?.id) {
      setAlert({ show: true, msg: 'Please select expense type', nextId: '' })
      return
    }
    if (!amount) {
      setAlert({ show: true, msg: 'Please enter amount', nextId: '' })
      return
    }
    const payload = {
      CompanyID: intCompanyID,
      UserID: intUserID,
      Headername: newHeader,
      PaymentCycleID: paymentCycle?.id,
      PaymentCycleName: paymentCycle?.label,
      IsFixed: txnType?.id === 1 ? 1 : 0,
      ExpenseTypeID: expenseType?.id,
      Amount: amount,
    }
    saveChanges(payload)
  }
  return (
    <Modal
      headTxt={`Add / Edit New Expense Header`}
      modalHeaderStyle={{ height: '53px' }}
      width={'90%'}
      height={'80vh'}
      updateModal={setModal}
      closeId={iid.closeButton}
    >
      <Item sx={{ padding: '0', height: 'calc(100% - 53px)', flexDirection: 'column', display: 'flex' }} className="reports">
        <Box sx={sx.reportFlex}>
          <Item sx={{ ...sx.itemsx, flex: 5 }} className={'input--wrapper'}>
            <LineinputV2 label="Add New Header" value={newHeader} onBlur={(e) => setNewHeaser(e.target.value)} />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              label={'Payment Cycle'}
              minWidth="250px"
              data={paymentCycles}
              dataKey="label"
              idKey="id"
              value={paymentCycle?.label}
              defaultvalue={paymentCycle?.label}
              onSelect={setPaymentCycle}
            />
          </Item>

          <Item sx={{ ...sx.itemsx, flex: 3 }} className="input--container bookingDatePicker">
            <Datepicker
              statusChecked={paymentCycle?.id !== 1}
              label={`Day of Month`}
              name={'from_date'}
              width="210px"
              startDate={moment().startOf('month')}
              endDate={moment().date(28)}
              value={dayOfMonth}
              dateChange={setDayOfMonth}
            />
          </Item>
          <Item sx={{ ...sx.itemsx, flex: 3 }}>
            <DropDownOA
              label={'Txn Type'}
              minWidth="250px"
              data={txnTypes}
              dataKey="label"
              idKey="id"
              value={txnType?.label}
              defaultvalue={txnType?.label}
              onSelect={setTxnType}
            />
          </Item>
          <Item sx={{ ...sx.itemsx, flex: 3 }}>
            <DropDownOA
              label={'Expense Type'}
              minWidth="250px"
              data={expenseTypes}
              dataKey="label"
              idKey="id"
              value={expenseType?.label}
              defaultvalue={expenseType?.label}
              onSelect={setExpenseType}
            />
          </Item>
          <Item sx={{ ...sx.itemsx, flex: 2 }} className={'input--wrapper'}>
            <LineinputV2 label="Amount" width="250px" filter={getFloat} value={amount} onBlur={(e) => setAmount(e.target.value)} />
          </Item>
          <Item sx={{ ...sx.itemsx, flex: 1 }} className="disabled-wrapper">
            <Button
              id="buttonLoad"
              variant="contained"
              onClick={addNewHeader}
              style={{ ...sx.fullHeight, ...sx.novp }}
              className="btn btn-primary"
            >
              ADD
            </Button>
          </Item>
        </Box>
        <Box sx={{ padding: 0, margin: '20px', height: '100%', overflowY: 'auto' }}>
          <Table>
            <TableHead />
            <TableRow>
              {ExpenseMasterHeaders.map((item) => {
                return (
                  <TableCell
                    style={{
                      backgroundColor: '#e5f3ff',
                      color: '#444',
                      fontSize: '12px',
                      lineHeight: '16px',
                      letterSpacing: '0.24px',
                      fontWeight: '600',
                      whiteSpace: 'pre-line',
                      padding: '6px 8px',
                      position: 'sticky',
                      top: 0,
                      zIndex: 1,
                      textAlign: item.align || 'left',
                    }}
                    colSpan={1}
                  >
                    {item?.header}
                  </TableCell>
                )
              })}
            </TableRow>
            <TableBody>
              {tableData.map((item, index) => {
                return (
                  <TableRow key={index}>
                    {ExpenseMasterHeaders.map((header) => (
                      <TableCell key={header.field} className="reportTD" style={{ textAlign: header.align || 'left' }}>
                        {header.field === 'Amount' ? (
                          <LineinputV2
                            key={index}
                            filter={floatFilter}
                            onBlur={(e) => handleChange(index, e.target.value)}
                            name="Amount"
                            disabled={item.disabled}
                            id={`Amount${index}`}
                            value={item.Amount}
                            onKeyDown={(e) =>
                              setTimeout(() => {
                                navigation1(e, `editButton${index}`, ``)
                              }, 0)
                            }
                          />
                        ) : header.field === 'edit_view' ? (
                          <Button
                            id="buttonLoad"
                            variant="contained"
                            style={{ ...sx.fullHeight, ...sx.novp }}
                            onClick={() => handleEdit(index, item.disabled, item)}
                            className="btn btn-primary"
                          >
                            {item.disabled ? 'Edit' : 'Save'}
                          </Button>
                        ) : (
                          item[header.field]
                        )}
                      </TableCell>
                    ))}
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>
        </Box>
      </Item>
    </Modal>
  )
}
